import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

import PinnedBuildingsContainer from '../Building/PinnedBuildingsContainer';

import { getIsAccessCardsShown, getIsReadOnlyAdmin } from '../../utils';
import {
  getIsCommunityShown,
  getIsEventsShown,
  getIsManagementCompanyShown,
} from './utils';

import { ACCESS_LEVELS } from './constants';

import {
  activityIcon,
  amenityIcon,
  buildingIcon,
  cardIcon,
  deliveryIcon,
  docIcon,
  eventsIcon,
  externalAccountIcon,
  ipIcon,
  monetizationIcon, // exportIcon,
  pmcIcon,
  remoteDoormanIcon,
  searchIcon,
  srIcon,
  visitorIcon,
} from '../../res/svg/icons';

export const getMenuData = (t) => [
  {
    access: ACCESS_LEVELS.ALL,
    type: 'sub-header',
    url: '',
    label: t('title.management'),
    subMenu: [
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsManagementCompanyShown(),
        type: 'item',
        url: `/pmcs`,
        label: t('title.managementCompany'),
        icon: pmcIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/pmcs',
        label: t('pmcSettings.pmc'),
        icon: pmcIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/buildings',
        label: t('title.buildings'),
        icon: buildingIcon,
        subMenu: [],
        subComponents: [PinnedBuildingsContainer],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/global-person-search',
        label: t('title.globalPersonSearch'),
        icon: searchIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/ip-management',
        label: t('title.ipManagement'),
        icon: ipIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/carson-activity',
        label: t('title.carsonActivity'),
        icon: activityIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        show: !getIsReadOnlyAdmin(),
        type: 'item',
        url: '/external-accounts-v2',
        label: t('title.externalAccounts'),
        icon: externalAccountIcon,
        subMenu: [],
      },
    ],
  },
  {
    access: ACCESS_LEVELS.ALL,
    type: 'sub-header',
    url: '',
    label: t('title.operations'),
    subMenu: [
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsCommunityShown(),
        type: 'item',
        url: '/community',
        label: t('title.community'),
        icon: <PeopleOutlineIcon sx={{ color: '#A246AD' }} />,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/deliveries',
        label: t('title.deliveries'),
        icon: deliveryIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/service-requests',
        label: t('title.serviceRequests'),
        icon: srIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/visitors',
        label: t('title.visitorManagement'),
        icon: visitorIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/remote-doorman',
        label: t('title.remoteDoorman'),
        icon: remoteDoormanIcon,
        customViewBox: '0 0 23 29',
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsAccessCardsShown(),
        type: 'item',
        url: '/access-cards',
        label: t('title.accessCards'),
        icon: cardIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/document-library',
        label: t('title.documentLibrary'),
        icon: docIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/amenity',
        label: t('title.amenityReservations'),
        icon: amenityIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsEventsShown(),
        type: 'item',
        url: '/events',
        label: t('title.events'),
        icon: eventsIcon,
        customViewBox: '0 0 24 24',
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        show: !getIsReadOnlyAdmin(),
        type: 'item',
        url: '/billing-report',
        label: t('title.monthlyBill'),
        icon: monetizationIcon,
        customViewBox: '0 0 24 24',
        subMenu: [],
      },
      /* {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/exports',
        label: t('title.exports'),
        icon: exportIcon,
        subMenu: [],
      }, */
    ],
  },
];
